if(!Shopify.designMode){
  const productRecommendationsSection = document.querySelector('.product-recommendations');
  
  if (productRecommendationsSection && productRecommendationsSection.dataset && productRecommendationsSection.dataset.url) {
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          
          const hasProducts = recommendations.querySelector('.related-product-row__item');
          if (!hasProducts) {
            productRecommendationsSection.style.display = 'none';
          }
        } else {
          productRecommendationsSection.style.display = 'none';
        }
        document.dispatchEvent(new CustomEvent('fm:related-products-loaded', { detail: { section: productRecommendationsSection } }));
      })
      .catch(e => {
        console.error(e);
        productRecommendationsSection.style.display = 'none';
        document.dispatchEvent(new CustomEvent('fm:related-products-loaded', { detail: { section: productRecommendationsSection, error: true } }));
      });

    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  }
}
else{
  document.addEventListener('DOMContentLoaded', function() {
    const productRecommendationsSection = document.querySelector('.product-recommendations');
    
    if (productRecommendationsSection && productRecommendationsSection.dataset && productRecommendationsSection.dataset.url) {
      const url = productRecommendationsSection.dataset.url;
      
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
          document.dispatchEvent(new CustomEvent('fm:related-products-loaded', { detail: { section: productRecommendationsSection } }));
        })
        .catch(e => {
          console.warn('Could not load product recommendations in design mode');
          document.dispatchEvent(new CustomEvent('fm:related-products-loaded', { detail: { section: productRecommendationsSection, error: true } }));
        });
    }
  });

  document.addEventListener('shopify:section:load', function(event){
    const prs = document.querySelector('.product-recommendations');
    
    if (prs && prs.dataset && prs.dataset.url) {
      const url = prs.dataset.url;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            prs.innerHTML = recommendations.innerHTML;
          }
          document.dispatchEvent(new CustomEvent('fm:related-products-loaded', { detail: { section: prs } }));
        })
        .catch(e => {
          console.warn('Could not load product recommendations on section load');
          document.dispatchEvent(new CustomEvent('fm:related-products-loaded', { detail: { section: prs, error: true } }));
        });
    }
  });
}

function handleIntersection(entries) {
  if (!entries[0].isIntersecting) return;
}
